<template>
    <div class="form">
        <el-form style="margin:20px;width:75%;min-width:600px;" label-width="180px">
            <el-form-item class='edit-form' label="销售下单号">
                <span>{{Form.OrderCode}}</span>
                <!--<el-button  @click="printGooodsPage" style="margin-left: 350px">打印出库单</el-button>-->
            </el-form-item>
            <el-form-item class='edit-form' label="发货通知单号">
                <span>{{Form.SendCode}}</span>
            </el-form-item>
            <el-form-item class='edit-form' label="出库单号">
                <span>{{Form.StockOutCode}}</span>
            </el-form-item>
            <el-form-item class='edit-form w100' label="代理商">
                <span>{{Form.AgentCode}} {{Form.AgentName}} {{Form.AgentAddress}} {{Form.AgentTel}}</span>
            </el-form-item>
            <el-form-item class='edit-form' label="业务员">
                <span>{{Form.SaleEmployeeName}}</span>
            </el-form-item>
            <!--<el-form-item class='edit-form' label="要求发货时间">-->
            <!--<span>{{Form.RequireSendDate}}</span>-->
            <!--</el-form-item>-->
            <el-form-item class='edit-form' label="实际发货时间">
                <span>{{Form.StockOutTime}}</span>
            </el-form-item>
            <el-form-item class='edit-form' label="实际签收时间">
                <span v-if="Form.SignTime!=''&&Form.SignTime!=undefined">{{Form.SignTime}}</span>
                <span v-else>--</span>
            </el-form-item>
            <div v-show="orderTypeShow">
                <el-form-item class='edit-form' label="申请时间">
                    <span>{{Form.ApplyTime}}</span>
                </el-form-item>
                <el-form-item class='edit-form' label="期望上课日期">
                    <span>{{Form.StartDate}}</span>
                </el-form-item>
                <el-form-item class='edit-form' label="园所名称">
                    <span>{{Form.SchoolName}}</span>
                </el-form-item>
                <el-form-item class='edit-form' label="课程名称">
                    <span>{{Form.OrderTitle}}</span>
                </el-form-item>
                <el-form-item class='edit-form' label="幼儿数">
                    <span>{{Form.Attendance}}</span>
                </el-form-item>
                <el-form-item label="开课申请表:">
                    <el-row style="margin-left: 25px;" v-if="JSON.stringify(Form.ApplicationForm)!='[]'">
                        <el-col :span="3" v-for="item in Form.ApplicationForm" style="margin-right:25px;margin-top:10px">
                            <div style="width:100%;border:4px solid RGB(205,205,205);border-radius:3px;line-height:0px;">
                                <img :src="item.Url" style="width:100%;display:block" @click="viewpic(item.Url)">
                            </div>
                        </el-col>
                    </el-row>
                    <span v-else>--</span>
                </el-form-item>
            </div>

            <el-form-item class='edit-form' label="发货通知单发货情况">
                <span>{{Form.DeliveryStatusName}}</span>
            </el-form-item>

            <el-form-item class='edit-form' label="套餐名称" v-show="Form.PackageName!=''">
                <span>{{Form.PackageName}}</span>
            </el-form-item>

            <el-form-item class='edit-form' label="商品" v-show="Form.ListGoods!=''" style="width:900px">
                <el-table :data="Form.ListGoods" border style="width: 80%;  margin-left: 25px;">
                    <el-table-column prop="ProName" label="名称">
                    </el-table-column>
                    <el-table-column label="包含单品" width="240">
                        <template scope="scope">
                            <div v-if="scope.row.PackDetail.length==0">--</div>
                            <div v-else class="dpDvCtnCss">
                                <div class="dpDvCss" v-for="PackDetail in scope.row.PackDetail">{{PackDetail.ProName}}</div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="ProNum" label="实发">
                    </el-table-column>
                    <el-table-column prop="ReceiveNum" label="实收">
                    </el-table-column>
                </el-table>
            </el-form-item>
            <el-form-item class='edit-form' label="赠品" v-show="Form.GiftGoods!=''" style="width:900px">
                <el-table :data="Form.GiftGoods" border style="width: 80%;  margin-left: 25px;">
                    <el-table-column prop="ProName" label="名称">
                    </el-table-column>
                    <el-table-column label="包含单品" width="240">
                        <template scope="scope">
                            <div v-if="scope.row.PackDetail.length==0">--</div>
                            <div v-else class="dpDvCtnCss">
                                <div class="dpDvCss" v-for="PackDetail in scope.row.PackDetail">{{PackDetail.ProName}}</div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="NeedSendNum" label="应发数">
                    </el-table-column>
                    <el-table-column prop="ProNum" label="实发">
                    </el-table-column>
                    <el-table-column prop="ReceiveNum" label="实收">
                    </el-table-column>
                </el-table>
            </el-form-item>
            <el-form-item class='edit-form w100' label="签收凭证">
                <div class="show-img-ctn uclear">
                    <template v-for="(item,index) in Form.ReceiptPic">
                        <div class="show-img-cell" @click="LookPicture(item.Url)">
                            <img :alt="item.Name" :src="item.Url" />
                        </div>
                    </template>
                </div>
            </el-form-item>

            <el-form-item class='edit-form w100' label="收货地址">
                <span>{{Form.AgentConsignee}}</span>
            </el-form-item>
            <el-form-item class='edit-form' label="收货人及联系方式">
                <span>{{Form.Consignee}}--{{Form.ConsigneeTel}}</span>
            </el-form-item>
            <el-form-item class='edit-form' label="寄送方式">
                <span>{{Form.SendModeName}}</span>
            </el-form-item>
            <el-form-item class='edit-form' label="支付方式">
                <span>{{Form.PayModeName}}</span>
            </el-form-item>
            <el-form-item class='edit-form' label="快递或物流名称">
                <span v-if="Form.LogisticsName!=''&&Form.LogisticsName!=undefined">{{Form.LogisticsName}}</span>
                <span v-else>--</span>
            </el-form-item>
            <el-form-item class='edit-form' label="快递或物流单号">
                <span v-if="Form.LogisticsCode!=''&&Form.LogisticsCode!=undefined">{{Form.LogisticsCode}}</span>
                <span v-else>--</span>
            </el-form-item>
            <el-form-item class='edit-form' label="包裹件数">
                <span>{{Form.PackageNum}}</span>
            </el-form-item>
            <el-form-item class='edit-form' label="出库单备注">
                <span v-if="Form.Remark!=''&&Form.Remark!=undefined">{{Form.Remark}}</span>
                <span v-else>--</span>
            </el-form-item>
            <el-form-item class='edit-form' label="">
                <el-button :plain="true" type="info" @click="goBack()">我知道了</el-button>
            </el-form-item>
        </el-form>
        <div class="picshow">
            <el-dialog v-model="picVisible" size="tiny">
                <img :src="picUrl" alt="">
            </el-dialog>
        </div>
    </div>
</template>
<script>
import NProgress from 'nprogress'
import { GetERP_StockOutById, GetERP_StockOutById2 } from '@api/stockOutApi.js';
import { cloneDeep, util, isCorrectVal, isDate, lg } from 'utils';
import viewPhoto from 'src/common/js/viewPhoto';

module.exports = {
    data() {
        return {
            PictureVisible: false,
            dialogImageUrl: "",
            Form: [],
            SignImg: [],
            OtherImg: [],
            picVisible: false,
            picUrl: ""
        }
    },
    methods: {
        viewpic(val) {
            this.picVisible = true;
            this.picUrl = val;
        },
        printGooodsPage() {
            util.redirect(this, '/SendGoods/ViewSendGoodsForStock/SendGoodsPage?Id=' + this.$route.query.Id + "&Goods=true", false);
        },
        LookPicture(Url) {
            viewPhoto.show({
                showImgId: "", //指定id显示图片
                thumbList: [{ src: Url, id: "" }]
            });
        }, goBack() {
            window.history.go(-1);
        }
    },
    created: function() {

        if (this.$route.query.Id != undefined && this.$route.query.Sid != undefined && this.$route.query.Session != undefined) {
            let _session = util.getSessin();
            let para = {
                Sid: _session[0],
                Session: _session[1],
                Id: this.$route.query.Id
            };

            GetERP_StockOutById2(para).then(res => {
                if (res.data.StateCode !== 0) {
                    if (res.data.StateCode == 99) {
                        this.$router.push('/login')
                    } else {
                        this.$notify({
                            title: '错误',
                            message: res.data.StateMsg,
                            type: 'error'
                        });
                    }
                } else {
                    this.Form = res.data.Data;
                    if (this.Form.SignImg.length > 0) {
                        for (var i = 0; i < this.Form.SignImg.length; i++) {
                            var b = {};
                            b.Url = this.Form.SignImg[i].Url;
                            b.Name = this.Form.SignImg[i].Name;
                            this.SignImg.push(b);
                        }
                    }

                    if (this.Form.OtherImg.length > 0) {
                        for (var i = 0; i < this.Form.OtherImg.length; i++) {
                            var b = {};
                            b.Url = this.Form.OtherImg[i].Url;
                            b.Name = this.Form.OtherImg[i].Name;
                            this.OtherImg.push(b);
                        }
                    }
                    lg(this.Form);
                }
            });
        }
    },
    computed: {
        orderTypeShow() {
            //OrderType
            //SO GK
            let orderType = $.trim(this.Form.OrderType);
            if (orderType.indexOf("SO") > -1 || orderType.indexOf("GK") > -1 || orderType.indexOf("SU") > -1) {
                return true;
            }
            return false;
        }
    }
}
</script>
<style scoped>
span {
    margin-left: 25px;
}

.ImgPrev {
    float: left;
    margin-right: 5px;
    margin-left: 20px;
    width: 80px;
    height: 80px;
    position: relative;
    margin-bottom: 6px;
}

.post-format-content {
    position: relative;
    background: white;
}

.post-thumbnail {
    max-width: 100%;
    height: auto;
    overflow: hidden;
}

.content-wrap {
    padding: 0;
    position: absolute;
    text-align: center;
    width: 100%;
    top: 0;
    bottom: 0;
    display: table-cell;
    vertical-align: middle;
    overflow: hidden;
    border-radius: 8px;
}

.entry-title {
    display: table;
    font-size: 110%;
    height: 100%;
    width: 100%;
    margin: 0;
}

.edit-link {
    z-index: 2;
}

.featured-image {
    display: table-cell;
    position: relative;
    /*       transition: opacity .25s ease-in-out, background .25s ease-in-out;
                -moz-transition: opacity .25s ease-in-out, background .25s ease-in-out;
                -webkit-transition: opacity .25s ease-in-out, background .25s ease-in-out;*/
    vertical-align: middle;
    z-index: 1;
    color: #fff;
    text-decoration: none;
    opacity: 0;
    padding: 10%;
}

.featured-image:hover {
    border-radius: 8px;
    opacity: 0.9;
    color: #fff;
    background: rgba(0, 0, 0, 0.8);
}

.post-thumbnail img {
    display: block;
}

img {
    max-width: 100%;
    height: auto;
}

.myProPic {
    width: 80px;
    height: 80px;
    border-radius: 8px;
}

.dpDvCss {
    border-bottom: 1px solid #ccc;
    line-height: 34px;
}

.dpDvCtnCss .dpDvCss:last-child {
    border: 0px!important;
}
</style>


// WEBPACK FOOTER //
// VStockOut.vue?8dd55c72